import { useState } from 'react'
import { useAuth } from 'src/hooks/auth'
import { CryptoBoard } from './components/CryptoBoard'
import { Exchange } from './components/Exchange'
import { LastTransactions } from './components/LastTransactions'
import { Machine } from './components/Machine'
import { PixArea } from './components/PixArea'
import { UserBalance } from './components/UserBalance'

export function Dashboard() {
  const { user } = useAuth()

  const document = user.document

  return (
    <section className="grid grid-rows-[1fr_0.8fr_1.2fr] grid-cols-2 font-montserrat items-center justify-center padding-section w-full h-full">
      {document === '57322029000107' && <Modal />}

      <div className="row-start-1 row-end-2 col-start-1 col-end-2 h-full w-full flex items-center justify-center relative left-3">
        <UserBalance />
      </div>
      <div className="row-start-1 row-end-2 col-start-2 col-end-3 h-full w-full flex items-center justify-center relative left-3">
        <PixArea />
      </div>

      <div className="row-start-2 row-end-3 col-start-1 col-end-2 w-full h-full flex justify-center items-center gap-section relative left-3">
        <div className="flex justify-center items-center w-full h-full gap-container-exchange-machine">
          <Exchange />
          <Machine />
        </div>
      </div>

      <div className="row-start-2 row-end-4 col-start-2 col-end-3 h-full w-full flex items-center justify-center relative left-3">
        <LastTransactions />
      </div>

      <div className="row-start-3 row-end-4 col-start-1 col-end-2 h-full w-full flex items-center justify-center relative left-3">
        <CryptoBoard />
      </div>
    </section>
  )
}

function Modal() {
  const [isOpen, setIsOpen] = useState(true)

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[500px]">
        <h2 className="text-lg font-semibold">
          Prezado(a) Cliente Amanda de Sousa Rodrigues,
        </h2>
        <p className="mt-2 text-sm text-gray-700">
          Informamos que sua conta foi temporariamente bloqueada para a
          realização de transações devido ao bloqueio do MEDs. Até o momento, o
          valor bloqueado é de <strong>R$ 9.595,75</strong>.
        </p>
        <p className="mt-2 text-sm text-gray-700">
          Por favor, aguarde até 24 horas para que possamos liberar a opção de
          atuação nos MEDs. Após esse período, será possível realizar as
          transações solicitadas em todos os MEDs.
        </p>
        <p className="mt-2 text-sm text-gray-700">
          Em caso de dúvidas, entre em contato através do e-mail:{' '}
          <a
            href="mailto:dev-bank@wtbo.com.br"
            className="text-blue-600 underline"
          >
            dev-bank@wtbo.com.br
          </a>
          .
        </p>
        <p className="mt-2 text-sm font-semibold">
          Agradecemos pela compreensão.
        </p>
        <p className="text-sm font-semibold">Atenciosamente,</p>
        <p className="text-sm font-semibold">Equipe Symbank</p>
        <button
          onClick={() => setIsOpen(false)}
          className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  )
}
